import { Component, HostListener, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-feedback-modal',
  templateUrl: './feedback-modal.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, TranslocoPipe, Button],
})
export class FeedbackModalComponent {
  @Input() data: any;
  @Input() close: ((event?: any) => void) | undefined;
  @Input() okClicked: ((feedback: any) => void) | undefined;

  feedbackControl = new FormControl('', [Validators.required]);

  public closeModal() {
    this.close?.();
  }

  public sendFeedback() {
    this.okClicked?.(this.feedbackControl.value || '');
  }

  @HostListener('document:keydown.escape')
  public onKeydownHandler() {
    this.closeModal();
  }
}
